// Package
import Multiselect from "vue-multiselect";
import { defineComponent } from "vue";

export default defineComponent({
    data() {
        return {
            valueSelected: null
        }
    },
  props: {
    label: {
      type: String,
      required: true,
      default: "",
    },
    value: {
      type: Object | Array | String | Number,
      required: true,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: String,
      required: true,
      default: "",
    },
    options: {
      type: Array,
      required: true,
      default: [],
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    errors: {
      type: Object,
      required: false,
      default: () => {},
    },
    col: {
      type: String,
      required: false,
      default: "12",
    },
    information: {
      type: String,
      required: false,
      default: null,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Multiselect,
  },
  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    onSelect(selectedOption) {
      this.$emit("onSelect", selectedOption);
    },
    onRemove(selectedOption) {
      this.$emit("onRemove", selectedOption);
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(v) {
        this.valueSelected = v
      },
    },
  },
});
